import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "关于我们", to: "/about" },
];

const friendlyLinks = ["影视资讯网", "剧集速递", "影迷社区", "片单推荐", "电影百科"];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-black text-background-50">
                91
              </span>
              <span className="font-heading text-lg font-bold text-background-50">看片</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/70">
              91看片是一个影视信息聚合与浏览平台，汇集电影、电视剧、综艺节目的分类资料、剧情简介与筛选查找能力，帮助你更快发现想看的内容，提升选片与观影体验。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-background-100/50">
              本站不提供视频存储、上传与付费服务，所有内容均为信息导航与展示用途。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#quick-nav">快速导航</a>
            </h4>
            <ul id="quick-nav" className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="cursor-pointer whitespace-nowrap text-sm text-background-100/70 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#friend-links">友情链接</a>
            </h4>
            <ul id="friend-links" className="mt-4 space-y-3">
              {friendlyLinks.map((name) => (
                <li key={name}>
                  <span className="cursor-pointer whitespace-nowrap text-sm text-background-100/70 transition-colors hover:text-accent-300">
                    {name}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-100/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 91看片 · 优质影视资源在线观看平台　保留所有权利（演示站点）</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span className="cursor-pointer whitespace-nowrap hover:text-accent-300">用户协议</span>
            <span className="cursor-pointer whitespace-nowrap hover:text-accent-300">版权声明</span>
            <span className="cursor-pointer whitespace-nowrap hover:text-accent-300">免责声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}